module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNTAwIiBoZWlnaHQ9IjUwMCI+DQo8dGl0bGU+dUtSWDwvdGl0bGU+DQo8cGF0aCBkPSJNIDAsMCBMIDUwMCw1MDAgTSAwLDUwMCBMIDUwMCwwIiBzdHJva2U9IiMwMDMzOTkiIHN0cm9rZS13aWR0aD0iMTAwIiAvPg0KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/xsymbol.svg
// module id = GbhY
// module chunks = 1